import sliceCreator from '../../index.jsx';
import {GET_ACTIVITY_BY_ID } from '../../../constants/index.jsx';
const _getActivityByIdAction = sliceCreator('GET_ACTIVITY_BY_ID', GET_ACTIVITY_BY_ID, 'get');

const { asyncAction: getActivityByIdAction, reducer, clearData: clearGetActivityByIdAction } = _getActivityByIdAction;

export default reducer;

export {
    getActivityByIdAction,
    clearGetActivityByIdAction
}